export default __webpack_public_path__ + "static/media/integrationDeliveryIcon.22ba049a.png";